import { render, staticRenderFns } from "./QuestionGeneral.vue?vue&type=template&id=4542cfde"
import script from "./QuestionGeneral.vue?vue&type=script&lang=js"
export * from "./QuestionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports